import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export function useUpdateWebinarPromotionTeamId() {
  const accessToken = getUserToken();
  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return (
    templateId: string | number,
    teamId: string | number,
  ): Promise<void> =>
    service
      .put(
        `/api/webinars/template/${templateId}/config/promotion-team-id/${teamId}`,
      )
      .set(headers)
      .then(tokenRefreshHandler)
      .then((res: Response) => res.body)
      // No other queries depend on this data, the cache invalidation
      // block is not needed here.
      .catch(errorHandler);
}
